module.exports = {
  login: {
    title: 'Account Login',
    rememberPsd:'Remember Password',
    forgetPsd:'Forget Password',
    signIn:'sign in',
    signUp:'sign up',
    enteraccount:'email/cell phone number',
    accountnot:'Account does not exist！',
    accountpassword:'password',
    entercode:'please enter verification code',
    ApplyQrCode:'Apply for a tag',
    ThirdPartyLogin: 'third party login',
    accountLength:'The account length has reached the maximum of 32',
    passwordLength:'The password length has reached the maximum of 16',
    noAccOrPsd: 'The account or password cannot be empty',
    enterid:'Enter product ID',
    scanphone:'Take a Photo to scan code',
    platform:'Dogness platform',
    areaCode:'Countries & Regions',
    agree:'Logging in is agreeing to a',
    privacyStatement:'privacy policy',
    setLoginPsw:'Please set the login password and confirm the password',
    pswSimple:'The password is too simple!'
  },
  btn: {
    text: 'button'
  },
  btmNavBar:{
    device:'Device',
    finder:'Looking for',//Signal relay--信号继电器
    my:'Mine'
  },
  finder: { //协寻列表
    find: 'Signal Relay',
    filtrateTime: 'time', //时间筛选
    filtrateDis: 'distance', //距离筛选
    noMoreFind:'No more assistant',
    pullRefresh:'Pull down to refresh',
    noComment:'No comments',
    noMoreComment:'All comments have been shown',
    comments:'The latest comments',
    enterComment:'Please enter comments!',
    notAccount:'Please log in to view the comments'
  },
  device: { //设备列表
    noLogin: 'You are not logged in, please log in to view the device',
    myDevice: 'MyDevice',
    deviceNull:'You have not added any Dogness Smart Products yet',
    goLogin:'Go Login',
    deviceCode: 'device ID',
    bindPet: 'Paired Pets',
    noBindPet: 'This device has not paired any pet',
    hint: 'If you need to delete the device, please unpair the pet and then delete it',
    unbind: 'Unpair',
    delDevice: 'Delete',
    addNewDevice:'Add new device',
    nobindDevice:'You have not paired any Dogness device',
    isDelete:'Do you want to delete the device ',
    deleteDevice:'delete device',
    nodevice:'No equipment at present',
    content:'Please contact customer service for purchase',
    contentnum:'400-891-8580',
    scanning:'Please scan and bind the hangtag two-dimensional code first.'  
  },
  addDevice:{
    // selectAddDevice:'Please select the device you want to access',
    // robot:'Dogness ipet robot',
    // feeder:'Dogness smart CAM feeder',
    // bread:'Dogness mini robot',
    // camrarobot:'Dogness smart CAM treater',
    // necklace:'Dogness smart collar',
    // tag:'Dogness assist location Pendant',
    scanQRC:'scan QR code',
    makePhotoSign:'Click the camera button above to scan Dogness QR code to pair the device',
    ifConntRecog:'If you can not identify it',
    inputQRC:'try entering the QR code number',
    recogQRC:'Identify the QR code in the selection',
    reMake:'I want to remake',
    chackYourId:'Detected your device ID is：',
    bingDev:'Binding equipment',
    recogging:'QR code is being recognized, please wait',
    conntRecog:'The QR code in the selection is not recognized. Please align the QR code or adjust a little bit of the selection content',
    QRCcontent:'Recognized QR code content',
    // abandonPhone:'Are you sure you want to abandon the picture you are editing?',
    // abandonEdit:'Abandon editing',
    cancel:'cancel',
    sure:'sure',
    successBind:'pair success',
    alreadyBinged:'The device has been paired',
    notexist:'The device does not exist!'
  },
  bindById:{
    inputId:'Input ID pairing device',
    pleaseInput:'Please enter the device QR code number',
    sureBind:'Confirm the binding',
    successBind:'pair success',
    alreadyBinged:'The device has been paired',
    faileBind:'Pairing failed, please enter the correct device number',
    cannotBind:'The device is not a tag and cannot be bound'
  },
  my: {
    myAccount: "my user",
    myPet: "My pets",
    masterInfo: 'Owner information',
    myFinder: 'My location assistance',
    changePsd: 'Change password',
    onlineService: 'Online customer  service',
    FAQ: 'Frequently asked questions',
    exit: 'Logout',
    isExit:'Whether to quit the login?',
    myname:'master'
  },
  searchmessage:{
    title:'title',
    describe:' Locator assistance introduction ',
    petphone:'Pet profile'
  },
  mysearch: {
    status: 'status',
    finding:'looking for',
    finded:'found',
    closed:'closed',
    time: 'time',
    publishFind: 'post location assistance',
    // clickToCheck: 'Click to check Scanned QR code Record',
    clickToCheck:'Click query scan code record',
    losePlace: 'Lost place',
    loseTime: 'Lost time',
    stopfind:'currently no pet is in searching',
    nofindpet:'currently no pet being found',
    nostoppet:'currently no pet being closed',
    success:'Successful release',
    lost:'Publishing failure',
  },
  changefindpetinfo: {
    changefind: ' location assistance modification',
    findPet: 'Search for pets',
    clickToChangePlace:'Click below to change locations',
    petPhotos: 'Pet photos (up to 3 photos)',
    publicRelation: 'disclosure contact ways',
    findStatus:'assist location status',
    commit:'submit',
    more:'Multiple choice',
    select:'Please choose',
    enterTitle:'Please enter a title below 20 words',
    describe:'Please give a detailed description of pet and lost',
    change:'being modified, please wait',
    failure:'request failed'
  },
  masterInfo:{
    masterInfo:'OwnerInformation',
    nickName:'NickName',
    sex:'gender',
    email:'email',
    phone:'contact phone',
    add:'contact address'
  },
  changepassword:{
    oldPsd:'Please enter old password',
    newPsd:'Please enter new password',
    againPsd:'Please enter new password again',
    trueChange:'confirm changes',
    notPsd:'Password cannot be empty',
    falsePsd:'Password is not correct',
    lessPsd:'Password cannot be less than 6 digits',
    notSamePsd:'Inconsistent password'
  },
  petDetails:{
    find:' Assist Location',
    findInfo:'assist locate detail',
    petintro:'pet description',
    relationPer:'contact person',
    relationWay:'contact information',
    relHelp:'related help',
    share:'share to',
    cancelshare:'cancel sharing',
    wx:'This is the WeChat browser',
    lost:'Lost place'
  },
  addpet:{
    cat:'cat',
    dog:'dog',
    addpet:"Add pet",
    setPetPortrait:'set up profile photo',
    petName:'Pet nick name',
    petType:'Pet breed',
    color:'Pet hair color',
    sex:'Pet gender',
    weight:'Pet weight',
    height:'Pet height',
    birthday:'Pet birthday',
    character:'Pet character',
    trueAdd:'Confirm add',
    flag2:'Can only be in English, numbers, underline, minus',
    notpetName:'Pet name not filled in',
    enterchinese:' Please enter Chinese or English',
    notpetType:'Pet breed not filled in',
    notpetColor:'Pet hair color not filled in',
    notpetSex:'Pet gender not choose',
    not:'Can only be numbers',
    enterweight:'enter weight',
    enterheight:'enter height',
    notWeight:'Pet weight not filled in',
    notHeight:'Pet height not filled in',
    selectData:'choose date',
    selectSex:'choose gender',
    notBirthday:'Date of birth not selected',
    entercharacter:'enter character',
    notcharacter:'Pet character not filled in',
    entername:'enter name',
    enterType:'enter breed',
    enterColor:'enter hair color',
    have:'cannot be blank',
    savechage:'save changes',
    petNews:'pet information',
    deletePet:'delete pet',
    report:'post assist location',
    submiting:'Submitting, please wait'
  },
  petstatus:{
  	petinfo:"To avoid losing your pet, please fill in your pet's information",
  	petlookafter:'Please take care of your pet to prevent losing it.',
  	petmissing:'I am lost, please take me home!',
  	petfinding:'Community search has been posted, please wait for information.',
  },
  mapinfo:{
    sure:'confirm'
  },
  activation:{
  	sure:'Activation',
  	success:'Successful activation',
  },
  introduction:{
  	sure:'Introduction'	,
  	introductiontitle:'Introduction of collaborative platform',
  	introduction01:'Let all caring people protect your dog',
  	introduction02:'Only 3 steps are required：',
  	introduction03:'Log in to fill in the information of the owner and the pet and activate use.',
  	introduction04:'Once activated, any user can scan the QR code to see the information of the owner and the pet',
  	introduction05:"If your pet gets lost, you can post a community search. If another person finds your pet and scans the QR code, you can receive your pet's current location and establish contact with the finder to let the pet return to you as soon as possible.",
  },
  lossinfo:{
  	sure:'Post lost',
  	close:'Close'
  },
  menu:{
  	changeinfo:'Modify information',
  	mytag:'My tag',
  	scanningrecord:'Scan code record'
  },
  changeinfos:{
  	sure:'confirm',
  	changeinfostitle:'Scan code record'
  },
  privacyStatement:{
    appPrivacy:' App Privacy statement',
    addEnglish:'1.An overview of data protection',
    addEnglish1:'General',
    phead:'The following gives a simple overview of what happens to your personal information when you visit our website. Personal information is any data with which you could be personally identified. Detailed information on the subject of data protection can be found in our privacy policy found below.',
    one:'Data collection on our website',
    addEnglish2:'Who is responsible for the data collection on this website?',
    onecontent:'The data collected on this website are processed by the website operator. The operator is contact details can be found in the website is required legal notice.',
    two:'How do we collect your data?',
    twocontent:'Some data are collected when you provide it to us. This could, for example, be data you enter on a contact form.',
    twocontent1:'Other data are collected automatically by our IT systems when you visit the website. These data are primarily technical data such as the browser and operating system you are using or when you accessed the page. These data are collected automatically as soon as you enter our website.',
    three:'What do we use your data for?',
    threecontent:'Part of the data is collected to ensure the proper functioning of the website. Other data can be used to analyze how visitors use the site.',
    
    addEnglish3:'What rights do you have regarding your data?',
    addEnglish4:'You always have the right to request information about your stored data, its origin, its recipients, and the purpose of its collection at no charge. You also have the right to request that it be corrected, blocked, or deleted. You can contact us at any time using the address given in the legal notice if you have further questions about the issue of privacy and data protection. You may also, of course, file a complaint with the competent regulatory authorities.',
    addEnglish5:'Analytics and third-party tools',
    addEnglish6:'When visiting our website, statistical analyses may be made of your surfing behavior. This happens primarily using cookies and analytics. The analysis of your surfing behavior is usually anonymous, i.e. we will not be able to identify you from this data. You can object to this analysis or prevent it by not using certain tools. Detailed information can be found in the following privacy policy.',
    addEnglish7:'You can object to this analysis. We will inform you below about how to exercise your options in this regard.',
    addEnglish8:'2. General information and mandatory information',
    addEnglish9:'Data protection',
    addEnglish10:'The operators of this website take the protection of your personal data very seriously. We treat your personal data as confidential and in accordance with the statutory data protection regulations and this privacy policy.',
    addEnglish11:'If you use this website, various pieces of personal data will be collected. Personal information is any data with which you could be personally identified. This privacy policy explains what information we collect and what we use it for. It also explains',
    addEnglish12:'how and for what purpose this happens.',
    addEnglish13:'Please note that data transmitted via the internet (e.g. via email communication) may be subject to security breaches. Complete protection of your data from third-party access is not possible.',
    addEnglish14:'Notice concerning the party responsible for this website',
    addEnglish15:'The party responsible for processing data on this website is:',
    addEnglish16:'Dogness Group LLC',
    addEnglish17:'4116 W Spring Creek Parkway Suite 100',
    addEnglish18:'Plano, 75024 Texas',
    addEnglish19:'Telephone: +1 (833-364-6377) ',
    addEnglish20:'Email: sales@dognessgroup.com',
    addEnglish21:'The responsible party is the natural or legal person who alone or jointly with others decides on the purposes and means of processing personal data (names, email addresses, etc.).',
    addEnglish22:'Revocation of your consent to the processing of your data',
    addEnglish23:'Many data processing operations are only possible with your express consent. You may revoke your consent at any time with future effect. An informal email making this request is sufficient. The data processed before we receive your request may still be legally processed.',
    addEnglish24:'Right to data portability',
    addEnglish25:'You have the right to have data which we process based on your consent or in fulfillment of a contract automatically delivered to yourself or to a third party in a standard, machine-readable format. If you require the direct transfer of data to another responsible party, this will only be done to the extent technically feasible.',
    addEnglish26:'SSL or TLS encryption',
    addEnglish27:'This site uses SSL or TLS encryption for security reasons and for the protection of the transmission of confidential content, such as the inquiries you send to us as the site operator. You can recognize an encrypted connection in your browser is address line when it changes from "http://" to "https://" and the lock icon is displayed in your browser is address bar.',
    addEnglish28:'If SSL or TLS encryption is activated, the data you transfer to us cannot be read by third parties.',
    addEnglish29:'Information, blocking, deletion',
    addEnglish30:'As permitted by law, you have the right to be provided at any time with information free of charge about any of your personal data that is stored as well as its origin, the recipient and the purpose for which it has been processed. You also have the right to have this data corrected, blocked or deleted. You can contact us at any time using the address given in our legal notice if you have further questions on the topic of personal data.',
    addEnglish31:'Opposition to promotional emails',
    addEnglish32:'We hereby expressly prohibit the use of contact data published in the context of website legal notice requirements with regard to sending promotional and informational materials not expressly requested. The website operator reserves the right to take specific legal action if unsolicited advertising material, such as email spam, is received.',
    addEnglish33:'3. Data collection on our website',
    addEnglish34:'Cookies',
    addEnglish35:'Some of our web pages use cookies. Cookies do not harm your computer and do not contain any viruses. Cookies help make our website more user-friendly, efficient, and secure. Cookies are small text files that are stored on your computer and saved by your browser.',
    addEnglish36:'Most of the cookies we use are so-called "session cookies." They are automatically deleted after your visit. Other cookies remain in your device is memory until you delete them. These cookies make it possible to recognize your browser when you next visit the site.',
    addEnglish37:'You can configure your browser to inform you about the use of cookies so that you can decide on a case-by-case basis whether to accept or reject a cookie. Alternatively, your browser can be configured to automatically accept cookies under certain conditions or to always reject them, or to automatically delete cookies when closing your browser. Disabling cookies may limit the functionality of this website.',
    addEnglish38:'Cookies which are necessary to allow electronic communications or to provide certain functions you wish to use (such as the shopping cart) are stored pursuant to Art. 6 paragraph 1, letter f of GDPR. The website operator has a legitimate interest in the storage of cookies to ensure an optimized service provided free of technical errors. If other cookies (such as those used to analyze your surfing behavior) are also stored, they will be treated separately in this privacy policy.',
    

    four:'Server log files',
    fourcontent:' The website provider automatically collects and stores information that your browser automatically transmits to us in "server log files". These are:',
    fourcontent1:'Browser type and browser version',
    fourcontent2:'Operating system used',
    fourcontent3:' Referrer URL',
    fourcontent4:'Host name of the accessing computer',
    fourcontent5:'Time of the server request',
    fourcontent6:'IP address',

    addEnglish39:'These data will not be combined with data from other sources.',
    addEnglish40:'The basis for data processing is Art. 6 (1) (f) GDPR, which allows the processing of data to fulfill a contract or for measures preliminary to a contract.',
    addEnglish41:'Contact form',
    addEnglish42:'Should you send us questions via the contact form, we will collect the data entered on the form, including the contact details you provide, to answer your question and any follow-up questions. We do not share this information without your permission.',
    addEnglish43:'We will, therefore, process any data you enter onto the contact form only with your consent per Art. 6 (1)(a) GDPR. You may revoke your consent at any time. An informal email making this request is sufficient. The data processed before we receive your request may still be legally processed. ',
    addEnglish44:'We will retain the data you provide on the contact form until you request its deletion, revoke your consent for its storage, or the purpose for its storage no longer pertains (e.g. after fulfilling your request). Any mandatory statutory provisions, especially those regarding mandatory data retention periods, remain unaffected by this provision.',
    addEnglish45:'5. Analytics and advertising',
    addEnglish46:'6. Plugins and tools',
    addEnglish47:'YouTube',
    addEnglish48:'Our website uses plugins from YouTube, which is operated by Google. The operator of the pages is YouTube LLC, 901 Cherry Ave., San Bruno, CA 94066, USA.',
    addEnglish49:'If you visit one of our pages featuring a YouTube plugin, a connection to the YouTube servers is established. Here the YouTube server is informed about which of our pages you have visited.',
    addEnglish50:'If you are logged in to your YouTube account, YouTube allows you to associate your browsing behavior directly with your personal profile. You can prevent this by logging out of your YouTube account.',
    addEnglish51:'YouTube is used to help make our website appealing. This constitutes a justified interest pursuant to Art. 6 (1) (f) GDPR.',
    addEnglish52:'Further information about handling user data, can be found in the data protection declaration of YouTube under  www.google.de/intl/de/policies/privacy.',

    five:'Google Maps',
    fivecontent:'This site uses the Google Maps map service via an API. It is operated by Google Inc., 1600 Amphitheatre Parkway, Mountain View, CA 94043, USA. ',
    fivecontent1:'To use Google Maps, it is necessary to save your IP address. This information is generally transmitted to a Google server in the USA and stored there. The provider of this site has no influence on this data transfer. ',

    addEnglish53:'The use of Google Maps is in the interest of making our website appealing and to facilitate the location of places specified by us on the website. This constitutes a justified interest pursuant to Art. 6 (1) (f) GDPR. ',
    addEnglish54:'Further information about handling user data, can be found in the data protection declaration of Google at www.google.de/intl/de/policies/privacy/.'
  
  },
  userInformation:{
    changeImg:'click on the profile photo to delete or replace',
    enterusername:'enter nick name',
    username:'Nickname',
    phonenumber:' Cellphone number',
    email:'Email address',
    savechage:'Save changes'
  },
  //sharon
  complete:{
    finishregister:'welcome registration complete',
    gologin:'login now'
  },
  emailproving:{
    register:'register account',
    lastStep:'one step away from registration',
    textone:'We have sent an activation email to your email address，',
    texttwo:'Please click on the link in the email to complete the registration!',
    resend:'If you have not received the email, please click Resend',
    ActivateAccount:'Enter the email activation account'
  },
  forgetpassword:{
    resetpassword:'reset Password',
    resetpasswordphone:'phone reset password',
    resetpasswordemail:'email reset password',
    setpassword:'set password',
    //手机在重置密码
    EnterPhone:'Please enter cell phone number',
    FalsePhone:'Phone number format is not correct',
    NoPhone:'Phone number not registered',
    NotPhone:'Cell phone number cannot be empty',
    NotCode:'Verification code cannot be empty!',
    NoMatch:'Verification code is not correct!',
    next:' Next Step',
    HadAccount:'Already have an account login',
    sendcode:'send the verification code',
    sendcode2:'send',
    sendContent2:'Please enter a comment!',
    // verify:'Click verification',
    verify:'Get code',
    resend:'Resend',
    notresend:'Text messages cannot be repeated',
    //邮箱在重置密码
    EnterEmail:'Please enter email address',
    FalseEmail:'Email address format is not correct',
    NoEmail:'Email has not been registered',
    NotEmail:'Email cannot be empty!',
    submit:'submit',
    findemail:'Retrieve email?',
    finish:'Finished',
    authcodeerror:'Wrong verification code',
    authcodeemail:'Please go to email for verification',
    notemail:'Email not filled',
    findphone:'Retrieve cell phone number?'
  },
  loginswiper:{
    goregister:'Register now'
  },
  mynews:{
    masternews:'Owner Information',
    mastername:'NickName',
    mastersex:'Gender',
    masteremail:'Email',
    masterphone:'Contact phone',//contact phone
    masteradr:'Contact address'//contact address
  },
  mynewsedit:{
    EditMasterNews:'Edit owner information',
    setImg:'set up profile photo',
    EnterMastername:'please enter nick name',
    ChoiceSex:' choose gender',
    EnterMasterphone:'Please enter contact phone number',
    EnterMasteradr:'Please enter contact address',
    finish:'Finished',
    boy:'male',
    girl:'female',
    failure:'upload failed!'
  },
  register:{
    registerphone:'cell phone register',
    registeremail:'email register',
    //手机注册
    registeredphone:'cellphone number has been registered',
    //邮箱注册
    registeredemail:'email has been registered',
    enterPsd:'enter password',
    againEnterPsd:'enter password again',
    notAgainPsd:'make sure password cannot be empty'
  },
  registerfalse:{
    failurelink:'link has expired'
  },
  resetemailproving:{
    lastone:'We have successfully sent email to your mailbox：',
    lasttwo:'Please follow the prompts to reset your password and save it properly！',
    resetPsdEmail:'Go to your mailbox to reset the password'
  },
  resetsuccess:{
    changesuccess:'Modify success'
  },
  //Sharon2018-11-13
  findPetInfo:{
    bound:'The device has been paired',
    enterplatform:'Enter the platform'
  },
  qrFindError:{
    deviceError:'This device is not recognized, ',
    toPlat:'please contact customer service'
  },
  releaseSearch:{
    report:'post assist location',
    title:'Please enter a title below 20 words',
    nottitle:'title not filled',
    decription:'The pet is lost and the owner is very concerned. Please contact the owner asap, thank you.',
    notneed:'request not filled',
    losttime:'Lost time',
    choicetime:'choose date',
    nottime:'time not selected',
    lostadr:'Lost place(Click below to change locations)',
    choicepet:'choose pet',
    petImg:'Pet photos (up to 3 photos)',
    opencontact:'disclosure contact ways',
    choice:'please choose',
    notcontact:'This contact method is not available, please replace or fill in',
    mastermessage:"Owner's message",
    preserve:'Save',
    cancel:'Cancel',
  },
  connectDevice:{
    accessnetwork:'Dogness smart device network access',
    configuration:'After the mobile phone generates the QR code, put about 15cm in front of the camera to calibrate, which makes it easier for the smart device camera to recognize the QR code.'
  },
  createQrCode:{
    wifiname:'Please enter the wifi name being connected',
    wifipassword:'Please enter the wifi password being connected',
    QrCode:'Generate QR code'
  },
  deviceManage:{
    proName:'Product name',
    proType:'Product type',
    proNum:'Product number',
    boundpet:'pair pet',
    noboundpet:'haven’t pair pet',
    nopet:'You haven’t added a pet',
    reportfindnews:'post location assist',
    unbind:'unpair device',
    failure:'failure'
  },
  binddevice:{
    boundDevice:'pair device:',
    clickAddDevice:'click to add device'
  },
  changepet:{
    name:'小小柴',
    surebind:'confirm pairing'
  },
  choosePet:{
    mycute:'my pet',
    choicecute:'choose pet'
  },
  //提示框
  prompt:{
    noactivationemail:'User account has not been activated! The email has been resent, please enter the email to active account！',
    messageerror:'account or password wrong',
    loginswiperError:'user name or password wrong',
    notapply:'not given',
    nocontact:'no contact information',
    openemail:'share email',
    openphone:'share cell phone',
    openall:'share cell phone and email',
    notChoicePet:'Pet not selected',
    notChoiceConcact:'contact information being shared has not been selected',
    notChoiceImg:'Pet life photos are not selected',
    found:'Your pet has posted location assist',
    notdevice:'the pet is not paired with any device',
    scan:'Please use third party QR code function',
    scanQrCode:'Please align the QR code to the device camera',
    bindpetsuccess:'Pair pet successfully!',
    removedevice:'Are you sure you want to unpair the device?',
    cancelchange:'Do you want to give up the modification?',
    delete:'This action will permanently delete the file, do you want to continue?',
    promptcancel:'prompt',
    remove:'unpair',
    sure:'confirm',
    cancel:'cancel',
    cancelbind:'unpair successfully',
    deletesuccess:'delete successfully',
    findingpet:'This pet is assisting location !',
    notcancel:'has cancelled pairing',
    feeder:'Dogness smart CAM feeder',
    bluetooth:'Bluetooth pedometer',
    robot:'Dogness ipet robot',
    QrCode:'Dogness assist location Pendant',
    necklace:'Dogness smart collar',
    mianbaoji:'Dogness mini robot',
    toushiqi:'Dogness smart CAM treater',
    sending:'Sending email, please wait！',
    boy:'boy',
    girl:'girl',
    notpetimg:'Pet photo has not been added',
    againlogin:'Account login expired, please log in again',
    addfailure:'Some information has not been filled in, add pet failed!',
    nopetlifepic:'Pet photo cannot be empty',
    cantdelete:'This pet is in location assistance or hasn’t unpaired from device, cannot delete!',
    canceldelete:'cancel delete',
    ycanceldelete:'already cancelled delete',
    choosePetone:'pet in location assistance cannot be paired',
    choosePettwo:'choose pet failure',
    header:'User login timed out, please log in again',
    slider:'Do you want to unpair pet ?',
    yslider:'unpair pet',
    finding:'This pet is under location assistance!',
    nodevice:'device does not exist, please contact customer service',
    bindfailure:'pair failure, device has been login by other user',
    contactkf:'Please contact customer service for system failure',
    noscan:'currently no QR code scan record',
    noApply:'Your browser does not support this type of sharing!',
    showTimes:'The number of times the device has been scanned is',
    noscan: 'No scan record',
    tokenfailure:'Authorization is invalid, please re-scan the code.',
    noexpression:'No support for facial expression input'
  },
  countries:{
    china:'China',
    hongkong:'China Hong Kong',
    macau:'China Macao',
    taiwan:'China Taiwan',
    America:'USA',
    Germany:'Germany',
    Japan:'Japan ',
    Albania: '阿尔巴尼亚',
    Algeria: '阿尔及利亚',
    Afghanistan: '阿富汗',
    Argentina: '阿根廷',
    UnitedArabemirates: '阿拉伯联合酋长国',
    Aruba: '阿鲁巴',
    Oman:'阿曼',
    azerbaijan:'阿塞拜疆',
    Egypt:'埃及',
    Ethiopia:'埃塞俄比亚',
    Ireland:'爱尔兰',
    Estonia:'爱沙尼亚',
    Andorra:'安道尔',
    Angola:'安哥拉',
    anguilla:'安圭拉',
    AntiguaAndBarbuda:'安提瓜和巴布达',
    Austria:'奥地利',
    Australia:'澳大利亚',
    Barbados:'巴巴多斯',
    PapuaNewGuinea:'巴布亚新几内亚',
    Bahamas:'巴哈马',
    Pakistan:'巴基斯坦',
    Paraguay:'巴拉圭',
    Palestine:'巴勒斯坦',
    bahrain:'巴林',
    panama:'巴拿马',
    Brazil:'巴西',
    belarus:'白俄罗斯',
    Bermuda:'百慕大',
    Bulgaria:'保加利亚',
    NorthKorea:'北朝鲜',
    NorthernMarianaIslands:'北马里亚纳群岛',
    BacNinh:'北宁',
    Belgium:'比利时',
    Iceland:'冰岛',
    PuertoRico:'波多黎各',
    Poland:'波兰',
    BosniaAndHerzegovina:'波斯尼亚和黑塞哥维那',
    Bolivia:'玻利维亚',
    Belize:'伯利兹',
    BozWana:'博兹瓦纳',
    Bhutan:'不丹',
    BurkinaFaso:'布基纳法索',
    Burundi:'布隆迪',
    EquatorialGuinea:'赤道几内亚',
    Denmark:'丹麦',
    EastTimor:'东帝汶',
    Togo:'多哥',
    Dominica:'多米尼加',
    DominicanRepublic:'多明尼加共和国',
    Russia:'俄国',
    Ecuador:'厄瓜多尔',
    eritrea:'厄立特里亚',
    France:'法国',
    TheFaroeIslands:'法罗群岛',
    FrenchPolynesia:'法属波利尼西亚',
    Vatican:'梵蒂冈',
    ThePhilippines:'菲律宾',
    Fiji:'斐济',
    Finland:"芬兰",
    CapeVerde:'佛得角',
    Franks:'佛兰克群岛',
    Gambia:'冈比亚',
    Congo:'刚果民主共和国',
    Colombia:'哥伦比亚',
    CostaRica:'哥斯达黎加',
    grenada:'格林纳达',
    Greenland:'格陵兰',
    Georgia:'格鲁吉亚',
    Cuba:'古巴',
    Guam:'关岛',
    Guyana:'圭亚那',
    kazakhstan:'哈萨克斯坦',
    Haiti:'海地',
    Korea:'韩国',
    Netherlands:'荷兰',
    NetherlandsAntilles:'荷属安的列斯',
    Montenegro:'黑山',
    Honduras:'洪都拉斯',
    Kiribati:'基里巴斯',
    djibouti:'吉布提',
    kyrgyzstan:'吉尔吉斯斯坦',
    guinea:'几内亚',
    Canada:'加拿大',
    Ghana:'加纳',
    Gabon:'加蓬',
    Cambodia:'柬埔寨',
    CzechRepublic:'捷克共和国',
    Zimbabwe:'津巴布韦',
    Cameroon:'喀麦隆',
    Qatar:'卡塔尔',
    CaymanIslands:'开曼群岛',
    Comorin:'科摩罗',
    Kuwait:'科威特',
    Croatia:'克罗地亚',
    Kenya:'肯尼亚',
    cookIslands:'库克群岛',
    Latvia:'拉脱维亚',
    Lesotho:'莱索托',
    Laos:'老挝',
    Lithuania:'立陶宛',
    Liberia:'利比里亚',
    Libya:'利比亚',
    Liechtenstein:'列支敦士登',
    reunion:'留尼汪',
    Luxembourg:'卢森堡',
    Rwanda:'卢旺达',
    Romania:'罗马尼亚',
    Madagascar:'马达加斯加',
    Maldives:'马尔代夫',
    Malta:'马耳他',
    Malawi:'马拉维',
    Malaysia:'马来西亚',
    Macedonia:'马其顿',
    MarshallIslands:'马绍尔群岛',
    Mauritius:'毛里求斯',
    Mauritania:"毛里塔尼亚",
    AmericanSamoa:'美属萨摩亚',
    Mongolia:'蒙古',
    Montserrat:'蒙特塞拉特',
    Bangladesh:'孟加拉国',
    Peru:'秘鲁',
    Micronesia:'密克罗尼西亚',
    Burma:'缅甸',
    Moldova:'摩尔多瓦',
    Monaco:'摩纳哥',
    Mozambique:'莫桑比克',
    Mexico:'墨西哥',
    Namibia:'纳米比亚',
    SouthAfrica:'南非',
    SouthSudan:'南苏丹',
    Nauru:'瑙鲁',
    Nicaragua:'尼加拉瓜',
    Nepal:'尼泊尔',
    Niger:'尼日尔',
    Nigeria:'尼日利亚',
    niue:'纽埃',
    Norway:'挪威',
    Palau:'帕劳',
    Portugal:'葡萄牙',
    Sweden:'瑞典',
    Switzerland:'瑞士',
    Salvador:'萨尔瓦多',
    Samoa:'萨摩亚',
    Serbia:'塞尔维亚',
    SierraLeone:'塞拉利昂',
    Senegal:'塞内加尔',
    Cyprus:'塞浦路斯',
    Seychelles:'塞舌尔',
    SaudiArabia:'沙特阿拉伯',
    SaoTomeandPrincipe:'圣多美和普林西比',
    SaintHelena:'圣赫勒拿',
    SaintKittsAndNevis:'圣基茨和尼维斯',
    SaintLucia:'圣卢西亚',
    SanMarino:'圣马力诺',
    SaintPierreandMiquelon :'圣皮埃尔和密克隆',
    SriLanka:'斯里兰卡',
    Slovakia:'斯洛伐克',
    Slovenia:'斯洛文尼亚',
    Swaziland:'斯威士兰',
    Sudan:'苏丹',
    Surinam:'苏里南',
    SolomonIslands:'所罗门群岛',
    Tajikistan:'塔吉克斯坦',
    Thailand:'泰国',
    Tanzania:'坦桑尼亚',
    Tonga:'汤加',
    Tunisia:'突尼斯',
    Tuvalu:'图瓦卢',
    Turkey:'土耳其',
    Turkmenistan:'土库曼斯坦',
    Tokelau:'托克劳',
    Vanuatu:'瓦努阿图',
    Guatemala:'危地马拉',
    Venezuela:'委内瑞拉',
    Brunei:'文莱',
    Uganda:'乌干达',
    Ukraine:'乌克兰',
    Uruguay:'乌拉圭',
    Uzbekistan:'乌兹别克斯坦',
    Spain:'西班牙',
    WesternSahara:'西撒哈拉',
    Greek:'希腊',
    Singapore:'新加坡',
    NewCaledonia:'新喀里多尼亚',
    NewZealand:'新西兰',
    Hungary:'匈牙利',
    Syria:'叙利亚',
    Jamaica:'牙买加',
    Armenia:'亚美尼亚',
    Yemen:'也门',
    Iraq:'伊拉克',
    Iran:'伊朗',
    Israel:'以色列',
    Italy:'意大利',
    India:'印度',
    Indonesia:'印度尼西亚',
    England:'英国',
    BVI:'英属维尔京群岛',
    BIOT:'英属印度洋领地',
    Jordan:'约旦',
    Vietnam:'越南',
    Zambia:'赞比亚',
    Chad:'乍得',
    Gibraltar:'直布罗陀',
    Chile:'智利',
    CentralAfricanRepublic:'中非共和国'
  }

}


// WEBPACK FOOTER //
// ./src/i18n/langs/en.js